var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / BR") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 4.66666667,
    cy: 4.66666667,
    r: 4.66666667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-BR",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "#05AB41",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.22868843,10.3636611 C2.91829238,10.1628166 2.92467316,9.83305462 3.22868843,9.63633886 L13.4379782,3.03032781 C13.7483743,2.82948331 14.2580065,2.83361204 14.5620218,3.03032781 L24.7713116,9.63633886 C25.0817076,9.83718336 25.0753268,10.1669454 24.7713116,10.3636611 L14.5620218,16.9696722 C14.2516257,17.1705167 13.7419935,17.166388 13.4379782,16.9696722 L3.22868843,10.3636611 Z",
    id: "Rectangle-60",
    fill: "#FDD216",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-2",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.333333, 5.333333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "none",
    fill: "#053087",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.666666667,4 C3.8524739e-14,3.33333336 2.41015625,3.64518235 4.66666667,4.00000001 C6.92317708,4.35481767 9.34145555,5.34145565 10,6",
    id: "Line",
    stroke: "#FFFFFF",
    strokeWidth: 1.33333333,
    fill: "none",
    strokeLinecap: "square",
    mask: "url(#mask-4)",
    transform: "translate(4.666667, 4.804198) rotate(6.000000) translate(-4.666667, -4.804198) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBr);
export default __webpack_public_path__ + "static/media/BR.9fbb1be6e7a4229d1e70f959848ba94d.svg";
export { ForwardRef as ReactComponent };